import authRu from './authRu'
import urlRu from './url'

/**
 * Часть словаря, которая нужна до загрузки основного: страницы авторизации
 * и названия страниц (их запрашивает parts/constants/pageUrl).
 * Попадает в главный бандл, поэтому сюда нельзя добавлять крупные разделы.
 */
const criticalRu = {
	url: urlRu,
	auth: authRu,
}

export default criticalRu
